<template>
  <MessageLayout
    image="./account-active.svg"
    title="Your Nobl9 account has been already set up."
    :contact-url="config.supportUrl"
  >
    You already set up your Nobl9 account. It is ready to use! Sign in to start
    your Nobl9 journey.
    <template v-slot:action>
      <el-button @click="goToSignIn">Go to Sign In page</el-button>
    </template>
  </MessageLayout>
</template>

<script lang="ts">
import { Options, Vue } from "vue-class-component";
import MessageLayout from "@/modules/messages/MessageLayout.vue";
import { configService } from "@/services/config-service";

@Options({
  components: { MessageLayout },
})
export default class MarketplaceAccountAlreadyActivated extends Vue {
  config = configService;

  goToSignIn(): void {
    window.location.href = this.config.signInUrl;
  }
}
</script>
